/**
|-------------------------------------------------------------|
| App - our main presenter file                               |
|-------------------------------------------------------------|
| Here is all the presenter code that is not in the main      |
| library concatenated by grunt                               |
|-------------------------------------------------------------|
*/
const isIE11 = !!window.msCrypto;
var mediaQueries = require('./helpers/classlist.js');
var Vue = require('../../node_modules/vue/dist/vue.min.js');
var Vuex = require('../../node_modules/vuex/dist/vuex.js');
var vueImagesLoaded = require('../../node_modules/vue-images-loaded/dist/vueimagesloaded.js');
var vueScrollTo = require('../../node_modules/vue-scrollto/vue-scrollto.js');

var axios = require('../../node_modules/axios/dist/axios.js');
var cookie = require('../../node_modules/js-cookie/src/js.cookie.js');
var parsley = require('../../node_modules/parsleyjs/dist/parsley.js');
var reframe = require('../../node_modules/reframe.js/dist/reframe.js');

import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

require('es6-promise/auto');
require('./helpers/findIndex.js');

Vue.use(Vuex);
Vue.use(vueScrollTo);

if (!isIE11) {
  var VS2 = require('vue-script2');
  Vue.use(VS2);
}

var store = new Vuex.Store({
  state: {
    currentTab : '',
    currentFilter: '',
    activeMenu : false,
    modalOpen: false,
    modalContent: '',
    modalProps: {},
    backgroundVideo: false,
  },
  getters: {
    getCurrentTab(state) {
      return state.currentTab;
    }
  },
  mutations: {
    saveActiveTab(state, payload) {
      state.currentTab = payload.name;
    },
    toggleSiteMenu(state) {
      state.activeMenu = !state.activeMenu;
    },
    toggleBackgroundVideo(state) {
      state.backgroundVideo = !state.backgroundVideo;
    },
    openModal (state) {
      state.modalOpen = true;
    },
    closeModal (state) {
      state.modalOpen = false;
    },
    changeModalContent (state, options) {
      state.modalContent = options.component;
      state.modalProps = options.props;
    },
    changeFilter (state, filter) {
      state.currentFilter = filter;
    }
  },
  actions: {
    setActiveTab(context, data) {
      context.commit('saveActiveTab', {
        name   : data.name
      });
    },
    toggleSiteMenu(context) {
      context.commit('toggleSiteMenu');
    },
    toggleBackgroundVideo(context) {
      context.commit('toggleBackgroundVideo');
    },
    openModal: ({ commit }) => commit('openModal'),
    closeModal: ({ commit }) => commit('closeModal'),
    changeModalContent: ({ commit }, options) => commit('changeModalContent', options),
    changeFilter: ({ commit }, filter) => commit('changeFilter', filter),
  }
});

var vm = new Vue({
	el: '#app',
	components: {
		'v-image'  				: () => import('./controllers/image-loader.vue'),
		'v-accordion'     : () => import('./controllers/accordion.vue'),
		'v-carousel'      : () => import('./controllers/carousel.vue'),
    'v-tab-nav'       : () => import('./controllers/tab-nav.vue'),
    'site-menu'       : () => import('./controllers/site-menu.vue'),
    'venue-search'    : () => import('./controllers/venue-search.vue'),
    'bg-image-css'    : () => import('./controllers/bg-image-css.vue'),

    'v-tab'              : () => import('./components/tab.vue'),
    'v-map'              : () => import('./components/map.vue'),
    'v-loading-bar'      : () => import('./components/loading-bar.vue'),
    'v-image-bg'  	     : () => import('./components/image-loader-bg.vue'),
    'image-carousel'     : () => import('./components/image-carousel.vue'),
    'gallery-index'      : () => import('./components/gallery-index.vue'),
    'gallery-block'      : () => import('./components/gallery-block.vue'),
    'v-modal'            : () => import('./components/modal.vue'),
    'venue-index'        : () => import('./components/venue-index.vue'),
    'news-index'         : () => import('./components/news-index.vue'),
    'resource-index'     : () => import('./components/resource-index.vue'),
    'profile-index'      : () => import('./components/profile-index.vue'),
    'quote-index'        : () => import('./components/quote-index.vue'),
    'walloffame-index'   : () => import('./components/walloffame-index.vue'),
    'hidden-element'     : () => import('./components/hidden-element.vue'),
    'loading-dots'       : () => import('./components/loading-dots.vue'),
    'background-video'   : () => import('./components/background-video.vue'),
    'scroll-to-dates'   : () => import('./components/scroll-to-dates.vue'),
    'timeline-nav'      : () => import('./components/timeline-nav.vue'),
    'pronounce-name'    : () => import('./components/pronounce-name.vue'),
    'v-embed'           : () => import('./components/embed.vue'),
  },
	//
 // 	components: {
	// 	'v-modal'         : require('./controllers/modal.vue'),
	// 	'v-image'  				: require('./controllers/image-loader.vue'),
	// 	'v-accordion'     : require('./controllers/accordion.vue'),
	// 	'v-carousel'      : require('./controllers/carousel.vue'),
  //   'v-tab-nav'       : require('./controllers/tab-nav.vue'),
  //   'venue-block'    : require('./controllers/venue-block.vue'),
  //
  //   'v-tab'           : require('./components/tab.vue'),
  //   'v-loading-bar'   : require('./components/loading-bar.vue'),
  //   'v-gallery'       : require('./components/gallery.vue'),
	// 	'v-mini-cal'      : require('./components/mini-cal.vue')
	// },
	delimiters : ['<%', '%>'],
	methods:{
		showModal: function(){
			this.$refs.modal.openModal();
		},
    toggleActiveTab:function(name) {
      this.$store.dispatch('setActiveTab', { name: name });
      console.log(this.$store.getters.getCurrentTab);
    },
		toggleClass: function(e){
			var $this = e.target;
			var $target = document.getElementById($this.dataset.toggleClassTarget);

			$this.classList.toggle('is-active');
			$target.classList.toggle('is-active');
		},
    toggleSiteMenu: function(e) {
      e.preventDefault();
      this.$store.dispatch('toggleSiteMenu');

      document.body.classList.toggle('is-active');
      document.querySelector('.c-site-header').classList.toggle('is-active');

      var $this = e.currentTarget;
      var menuText = $this.querySelector('.c-site-header__menu-text');
      
      $this.classList.toggle('is-active');

      if ($this.classList.contains('is-active')) {
        $this.ariaLabel = 'Menu close.'
        menuText.textContent = 'Close';
      } else {
        $this.ariaLabel = 'Menu open.'
        menuText.textContent = 'Menu';
      }
    },
    openModal: function(e) {
      this.$store.dispatch('openModal');
    },
    goToUrl: function (url, e) {
      if (e.target.localName !== "a") {
        window.location.href = url;
      }
    },
    parseQueryString: function() {
      var urlQueryString = document.location.search;
      var query = {};
      var pairs = (urlQueryString[0] === '?' ? urlQueryString.substr(1) : urlQueryString).split('&');

      for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split('=');
          query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }
      return query;
    },
    updateQueryString: function(key, value) {
      var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
          urlQueryString = document.location.search,
          newParam = key + '=' + value,
          params = '?' + newParam;

      // remove the hash part before operating on the uri
      var uri = location.href;
      var i = uri.indexOf('#');
      var q = uri.indexOf('?');
      var hash = getHash(uri);

      function getHash(uri) {
        var i = uri.indexOf('#');
        var q = uri.indexOf('?');

        if (i === -1) {
          return '';
        } else {
          if (q === -1) {
            return uri.substring(i);
          } else {
            return  uri.substring(i, q);
          }
        }
      }

      // If the "search" string exists, then build params from it
      if (urlQueryString) {
          var keyRegex = new RegExp('([\?&])' + key + '[^&]*');

          // If param exists already, update it
          if (urlQueryString.match(keyRegex) !== null) {
              params = urlQueryString.replace(keyRegex, "$1" + newParam);
          } else { // Otherwise, add it to end of query string
              params = urlQueryString + '&' + newParam;
          }
      }

      window.history.pushState({}, "", baseUrl + hash + params);
    }
	},
	mounted: function () {
    window.addEventListener('load', () => {
        setTimeout(() => {
          var bgImages = document.querySelectorAll('.o-image-bg');

          for(var i=0;i<bgImages.length;i++){
            bgImages[i].classList.add('is-loaded');
          }

          document.getElementById('inlineCssMain').parentNode.removeChild(document.getElementById('inlineCssMain'));
          document.getElementById('inlineCssDesktop').parentNode.removeChild(document.getElementById('inlineCssDesktop'));

          var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
          var showHeaderVideo = document.querySelector('.c-page-header--video .c-page-header__video');

          if (!supportsTouch) {
            this.$store.dispatch('toggleBackgroundVideo');
          }

          if (showHeaderVideo) {
             setTimeout(function(){
               showHeaderVideo.classList.add("is-active");
             },1000);
          }

          var accordionTabs = document.querySelectorAll('.js-accordion-tabs');
          var accordionLinks = [];
          var accordionContents = [];

          for (var j = 0; j < accordionTabs.length; j++) {

            var accordion = accordionTabs[j];

            accordionLinks[j] = accordion.querySelectorAll('.c-nav__link');
            accordionContents[j] = accordion.querySelectorAll('.c-accordion-tabs__item');

            for (var k = 0; k < accordionLinks[j].length; k++) {

              // assign links to accordion parent so only siblings are hidden (multiple accordion fix)
              accordionLinks[j][k].setAttribute('data-accordion-parent', j);

              accordionLinks[j][k].addEventListener("click",function(e){
                 e.preventDefault;

                 var accordionParent = this.getAttribute('data-accordion-parent');

                 //  Hide all items in the active accordion
                 for (var l = 0; l < accordionContents[accordionParent].length; l++) {
                  accordionLinks[accordionParent][l].classList.remove('is-active');
                  accordionContents[accordionParent][l].open = false; 
                 }

                 //  Display the selected accordion item
                 document.getElementById(this.getAttribute('href').replace('#','')).open = true;
                 this.classList.add('is-active');

              },false);
            }
          }

          // var bookButtons = document.querySelectorAll('.js-date-list__btn');
          //
          // for (var j=0;j<bookButtons.length;j++) {
          //   bookButtons[j].addEventListener('click', function(event) {
          //     event.preventDefault();
          //     var $this = this;
          //     $this.classList.add('is-loading');
          //
          //     fbq('trackCustom', 'ClickedBookButton', {
          //       event_name: $this.getAttribute('data-event'),
          //       event_venue: $this.getAttribute('data-venue'),
          //       event_startDate: $this.getAttribute('data-start-date'),
          //       event_endDate: $this.getAttribute('data-end-date'),
          //     });
          //
          //     setTimeout(function(){
          //
          //     },500);
          //   },
          //   false);
          // }
        }, 100);
    });

    // Load twitter widgets
    // This is becuase twitter widgets are not being initialised within Vue tabs
    setTimeout(function() {
      reframe('.o-embed > .fetch--youtube > iframe');
      reframe('.o-embed > .fetch--vimeo > iframe');

      if (twttr) {
        twttr.widgets.load(document.getElementsByClassName('c-site-main'));
      }
    }, 1000);

    // Background image css
    if (typeof(scCss) != 'undefined') {
      let head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style');

      style.type = 'text/css';
      if (style.styleSheet){
        style.styleSheet.cssText = scCss;
      } else {
        style.appendChild(document.createTextNode(scCss));
      }

      head.appendChild(style);
    }


	},
  store : store
});



// WEBPACK FOOTER //
// ./source/scripts/app.js